import React, { useState } from "react";
import Location from "react-autosuggest";
import debounce from "lodash/debounce";
import Request from "axios-request-handler";
import { Urls } from "../../Urls";
import "./AutoComplete.css";
import { withRouter } from "react-router-dom";

export const requestInstance = new Request({
  lockable: false,
  cancelable: true,
  errorHandler: (error, method) => {},
});
const AutoComplete = ({
  onSelect,

  placeholder,
  onChange,
  value,
  key,
  inputClassName = "",
  id = "Autosuggets_Input_id",
}) => {
  const [suggestions, setSuggestions] = useState([]);
  const [noSuggestions, setNoSuggestions] = useState(false);
  const [show, setShow] = useState(false);

  const onSuggestionsFetchRequested = debounce(({ value }) => {
    // console.log(value,"value aut");
    if (value.length >= 3) {
      let url = `${Urls.Autocomplete}?suggest=${value}&limit=20&searchFields=new_locations`;
      requestInstance.setUrl(url);
      if (requestInstance.isPending("get")) {
        requestInstance.cancel("get");
      }
      setShow(true);
      requestInstance
        .get()
        .then((res) => {
          setSuggestions([]);
          setSuggestions(res.data.value);
          setShow(false);
          if (res && res.data && res.data.value && res.data.value.length > 0) {
            if (res?.data?.value?.length < 1) {
              setNoSuggestions(true);
            } else {
              setNoSuggestions(false);
            }
          } else {
            setNoSuggestions(true);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, 500);
  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };
  const getSuggestionValue = (value) => {
    return value.location_name;
  };
  const renderSuggestion = (value) => {
    return value.location_name;
  };
  const onSuggestionSelected = (
    event,
    { suggestion, suggestionValue, suggestionIndex, sectionIndex, method },
  ) => {
    onChange(suggestion.location_name);
    onSelect(suggestion);
  };
  const clearInput = () => {
    onChange("");
    setSuggestions([]);
    setNoSuggestions(false);
  };

  const inputProps = {
    value: value,
    onChange: (e) => onChange(e.target.value),
    placeholder: placeholder,
    key: key,
    id: id,
    className: inputClassName,
  };
  return (
    <div className="Loader-Container">
      <Location
        suggestions={suggestions}
        onSuggestionsFetchRequested={(value) =>
          onSuggestionsFetchRequested(value)
        }
        onSuggestionsClearRequested={(e) => onSuggestionsClearRequested()}
        getSuggestionValue={(value) => getSuggestionValue(value)}
        renderSuggestion={(value) => renderSuggestion(value)}
        onSuggestionSelected={onSuggestionSelected}
        inputProps={inputProps}
      />
      {value && (
        <button className="clear-button" onClick={clearInput}>
          &times;
        </button>
      )}
      <div className={`preloader-wrapper small ${show ? "active" : ""}`}>
        <div className="spinner-layer" style={{ borderColor: "#3e3c3c" }}>
          <div className="circle-clipper left">
            <div className="circle"></div>
          </div>
          <div className="gap-patch">
            <div className="circle"></div>
          </div>
          <div className="circle-clipper right">
            <div className="circle"></div>
          </div>
        </div>
      </div>
      {noSuggestions && <div className="no_suggestion">No location found</div>}
    </div>
  );
};

export default withRouter(AutoComplete);
